module.exports = __webpack_public_path__ + "static/media/living-la-vida-vegan.cd232e88.mp4";